import { useBankOnboarding } from "./hooks/useBankOnboarding";
import BankOnboardingView from "./view";

export default function BankOnboardingCard() {
    const props = useBankOnboarding();
    return <BankOnboardingView {...props} />;
}
